import { makeAutoObservable, runInAction } from 'mobx';
import agent from '../../api/agent';
import {
  CRM_Metadata,
  CRM_MetadataInitialState,
  cutlistCompleteTypes,
  handleFindDifferences,
  reAllocationInitialState,
  reAllocationTypes,
  returntaskStatus,
} from '../CRMStore/types';
import {
  componentsProps,
  optionsInitial,
  subtaskTypes,
  taskDetails,
  taskDetailsInitial,
  taskTypes,
  titileInformation,
  titileInformationInitialState,
  roleBasedCardHiddenForTask,
  roleBasedCardHiddenForsubtask,
  dropdownDetailsProps,
  CutlistStatusInitial,
  CutlistStatusTypes,
  options
} from './types';
import NFAI_Restoration_SmartflowServices from './service';
import { store } from '../store';
import { v4 as uuid } from 'uuid';
import { updateHistoryMain } from '../../models/history';
import sendRespectiveEmail from '../../models/EmailNew';
import { toast } from 'react-toastify';
import { name } from 'faker';

export default class NFAI_Restoration_SmartflowsStore {
  loader: {
    tableLoader: boolean;
    buttonLoader: boolean;
  } = {
    tableLoader: false,
    buttonLoader: false,
  };
  showButton = {
    start: false,
    complete: false,
    Resume: false,
  };
  taskDetails: { task: string; count: number }[] = [];
  SubtaskDetails: {
    subtask: string;
    count: number;
  }[] = [];
  selectedItems: { task: string; subtask: string } = { task: '', subtask: '' };
  titileInformation: {
    details: titileInformation[];
    count: number;
    activeInformation: taskDetails;
  } = {
    details: [titileInformationInitialState],
    count: 0,
    activeInformation: taskDetailsInitial,
  };
  subtaskCompoent: {
    isModel: boolean;
    elements: CRM_Metadata[];
    elementCopy: CRM_Metadata[];
    reAllocationList:reAllocationTypes;
  } = {
    isModel: false,
    elements: [CRM_MetadataInitialState],
    elementCopy: [CRM_MetadataInitialState],
    reAllocationList: reAllocationInitialState
  };
  dropdownDetails:dropdownDetailsProps = {
    titleList: [optionsInitial],
    selectedTitle: '',
    reelList: [optionsInitial],
    selectedReel: '',
    empIdList: [optionsInitial],
    selectedEmpId: '',
    empNameList: [optionsInitial],
    selectedEmpName: '',
  };
  templateId: string = '';
  errorMessage: any = {};
  onSubmitChecker: boolean = false;
  isMandatory: boolean = false;
  ReportsLoader:boolean = false;
  cutlistStatusReportData:CutlistStatusTypes[]= [CutlistStatusInitial]
  cutlistCompleteList: any[] = [];
  cutlistCompleteFilmTitleList: options[] = [optionsInitial];
  cutlistCompleteReelList: options[] = [optionsInitial];
  cutlistCompleteLoader: { 
   tableLoader:boolean,
   filmTitleLoader:boolean
   } = {
   tableLoader: false,
   filmTitleLoader: false
   }
  
  constructor() {
    makeAutoObservable(this);
  }

  handleTemplateL2 = async (templateId: string) => {
    try {
      let result = await agent.NFAIReport.NFAITemplateL2(templateId);
      return result.data;
    } catch (error) {
      this.loader.tableLoader = false;
      console.log(error);
    }
  };
  handleTemplateL3 = async (templateId: string, currentTask: string) => {
    try {
      this.loader.tableLoader = true;
      const subtaskResponse =
        await agent.NFAIReport.NFAITemplateL3(templateId, currentTask);
        runInAction(()=>{
          // subtask list
          this.SubtaskDetails = subtaskResponse.data;
        });
      this.loader.tableLoader = false;
      return subtaskResponse.data;
    } catch (error) {
      this.loader.tableLoader = false;
      console.log(error);
    }
  };

  handleTableDetails = async (pageNumber: number, payload: any) => {
    // Table showing
    try {
      this.loader.tableLoader = true;
      const [response, count] = await Promise.all([
        await NFAI_Restoration_SmartflowServices.NFAISmartTracker(pageNumber, payload),
        NFAI_Restoration_SmartflowServices.nfaiSmartTrackerCount(payload),
      ]);
      runInAction(() => {
        const replaceAllValue = (value:string) =>{
          return value?.replaceAll('R02_S01','')?.replaceAll('S01','')?.replaceAll('PCPL','')
        }
        const replaceList = response.data.map((e: any) => ({
          ...e,
          status: e.status === '0' ? 'Yet to Start' : e.status === '1' ? 'Started' : e.status === '3' ? 'Hold': e.status === '4' ? 'Resumed' : 'InProgress',
          Previous_Owner_Employee_ID: replaceAllValue(e.physical_location_shelf),
          Previous_Owner_Employee_Name: replaceAllValue(e.physical_location_vault),
          LockedBy: replaceAllValue(e.physical_location_rack),
          Titlestatus: e.assetCondition,
          ...(this.selectedItems.subtask === 'Quality Check' && { 'Submission_Date': e.asset_In_Vault }),
        }));        
        const keysToExtract =
          (localStorage.getItem(`SmartTracker`) || '').split(',') || [];
        this.titileInformation.details = this.tableDestructure(
          replaceList,
          keysToExtract,
        );
        this.titileInformation.count = count.data;
        this.loader.tableLoader = false;
      });
    } catch (error) {
      this.loader.tableLoader = false;
      console.log(error);
    }
  };
  tableDestructure = (reponse: any[], keysToExtract: string[]) => {
    // destructure function
    const extractedData = reponse?.map((element: any) => {
      const extractedObject: any = {};
      element?.metadata?.forEach((values: any) => {
        keysToExtract?.forEach((item: any) => {
          if (
            values?.elementName?.toLowerCase()?.replaceAll(/ /g, '_') ===
            item?.toLowerCase()
          ) {
            extractedObject[item?.replaceAll(/ /g, '_')] = values.elementValue;
          } else {
            if (
              values?.elementName?.toLowerCase()?.replaceAll(/ /g, '_') ===
              item?.toLowerCase()
            ) {
              extractedObject[item] = values?.elementValue;
            }
          }
        });
      });
      Object.entries(element).forEach(([key, value]: [string, any]) => {
        keysToExtract?.forEach((item: any) => { 
          if (key?.toLowerCase() === item?.toLowerCase()) {
            extractedObject[item?.replaceAll(/ /g, '_')] = value as string; // Type assertion to string
          }
        });
      });
      extractedObject['id'] = element?.id;
      return extractedObject;
    });
    return extractedData;
  };

  resetButtons = () => {
    this.showButton = {
      start: false,
      complete: false,
      Resume: false,
    };
  };
  resetDropdown = () => {
    this.dropdownDetails = {
      ...this.dropdownDetails,
      selectedTitle:'',
      selectedReel:'',
      selectedEmpId:'',
      selectedEmpName:''
    }
  };

  statusButtonShow = (status: number) => {
    // button showing function
    this.resetButtons();
    if (status === 0) {
      this.showButton.start = true;
    } else if (status === 1 || status === 4) {
      this.showButton.complete = true;
    } else if (status === 3) {
      this.showButton.Resume = true;
    } else {
      this.resetButtons();
    }
  };

  handleComponents = async (
    statusNumber: number,
    restorationPayload: any,
    statusPayload: any,
    historyPayload: any,
    statusUpdate: { id: string; itemId: string; SubTkStatus: string },
    tablePayload: componentsProps,
  ) => {
    try {
      const {
        itemId,
        status,
        taskId,
        taskName,
        subTaskName,
        subTaskId,
        title,
      } = tablePayload;
      const newlist = handleFindDifferences(
        this.subtaskCompoent.elements,
        this.subtaskCompoent.elementCopy,
      );
      await newlist.forEach(async (elem) => {
        const { elementName, elementValue } = elem;
        let viewTemplatepayload = {
          id: uuid(),
          itemId,
          taskId,
          taskName,
          subTaskName,
          subTaskId,
          elementName,
          elementValue,
          dateTime: new Date().toISOString(),
          status: returntaskStatus(status),
        };
        const historyPayload = {
          taskId,
          taskName,
          subTaskId,
          subTaskName,
          status: `${store.userStore.user?.displayName} set "${elem.elementName}" as "${elem.elementValue}" for ${title}`,
          date: new Date(),
        };
        await agent.TaskFormTaskServices.updateComponentsValuesInHistory(
          viewTemplatepayload,
        );
        await updateHistoryMain(
          historyPayload,
          true,
          false,
          true,
          itemId,
          title,
        );
        sendRespectiveEmail(
          'edited',
          title,
          'Edited WorkFlow in Asset',
          '',
          '',
          '',
          `Dear ${store.userStore?.user?.displayName},<br/>\u00A0 This notification is to inform you that you have  set ${elem.elementName} as ${elem.elementValue} for ${title}". <br/> <br/> Regards, <br/> info@honeycombmanager.com`,
          true,
        );

        let viewTemplatePayload = {
          id: uuid(),
          itemId,
          taskId: taskId,
          taskName: taskName,
          subTaskName: subTaskName,
          subTaskId: subTaskId,
          elementName: elem.elementName,
          elementValue: `${elementValue}`,
          dateTime: new Date().toISOString(),
          status: returntaskStatus(status),
        };
        await agent.TaskFormTaskServices.updateComponentsValuesInHistory(
          viewTemplatePayload,
        );
      });
      const filterElements = this.subtaskCompoent.elements.filter(
        (el: any) => !el.isDynamic,
      );
      const subTaskConst = {
        ...this.titileInformation.activeInformation.taskData,
        actionerName: [1, 8, 4].includes(status)
          ? store.userStore.user?.displayName || ''
          : this.titileInformation.activeInformation?.taskData?.actionerName ||
            '',
        subTaskId: subTaskId,
        subTaskName: subTaskName,
        subTaskDateTime:
          this.titileInformation.activeInformation?.taskData.subTaskDateTime,
        templateSubtaskId:
          this.titileInformation.activeInformation?.taskData.templateSubtaskId,
        isActive: this.titileInformation.activeInformation?.taskData.isActive,
        isDeleted: this.titileInformation.activeInformation?.taskData.isDeleted,
        subtaskIndex:
          this.titileInformation.activeInformation?.taskData.subtaskIndex,
        elements: filterElements,
        communication:
          this.titileInformation.activeInformation?.taskData.communication,
        api: this.titileInformation.activeInformation?.taskData
          .activeInformation?.taskData.api,
        files: this.titileInformation.activeInformation?.taskData.files,
        status: status,
        isCurrentSubtask: true,
      };
      await store.ElementStore.uploadFilesSubTask(subTaskConst, subTaskId);

      if (status !== 1) {
        const payload = this.subtaskCompoent.elements
          .filter(
            (e) =>
              e.elementName !== 'Approved / Reject' &&
              e.elementName !== 'QC Approved / Reject',
          )
          .map((e) => {
            return { id: e.elementId, value: e.elementValue };
          });
        await agent.workflowSubtasks.updateElementDetailsAPI(payload);
      }
      runInAction(async () => {
        await this.handleStatusUpdate(
          statusNumber,
          restorationPayload,
          statusPayload,
          historyPayload,
          statusUpdate,
          tablePayload,
        );
      });
    } catch (error) {
      this.loader.buttonLoader = false;
      console.log(error);
    }
  };
  handleStatusUpdate = async (
    statusNumber: number,
    restorationPayload: any,
    statusPayload: any,
    historyPayload: any,
    statusUpdate: any,
    tablePayload: any,
  ) => {
    try {
      const { title } = tablePayload;
      await store.viewStore.NFAIworkFlowProcessChangesUpdate(statusPayload);
      await agent.Restoration.NFAIrestoHoursUpdate(restorationPayload);
      if(statusNumber === 2){
        let isRejected = false;
        if(restorationPayload.subTaskName === 'Self QC'){
          isRejected = this.subtaskCompoent.elements.find(e => e.elementName === "Approved / Reject")?.elementValue === 'Reject';
        }
        else if(restorationPayload.subTaskName === 'Quality Check') {
          isRejected = this.subtaskCompoent.elements.find(e => e.elementName === "QC Approved / Reject")?.elementValue === 'Reject';
        }

        if(isRejected) statusNumber = 5;
      }
      await NFAI_Restoration_SmartflowServices.nfaicutliststatusUpdate(statusUpdate.itemId,restorationPayload.subTaskName,statusNumber.toString())
      await updateHistoryMain(
        historyPayload,
        true,
        true,
        true,
        statusUpdate.itemId,
      );
      const shouldSendApiRequest =
        this.subtaskCompoent.elements.length !== 0 &&
        restorationPayload.subTaskName === 'Restoration';
      if (shouldSendApiRequest) {
        const element = shouldSendApiRequest
          ? this.subtaskCompoent.elements.find(
              (e) => e.elementName === 'Image Restoration',
            )?.elementValue || ''
          : '';
        const parsedValue = element
          ? JSON.parse(element.split('DynamicTable|')[1])
          : {};
        const condition = parsedValue.some(
          (e: any) =>
            e['Tools used'] === '[]' || e['Tools used'] === '' || e['Image_restoration_details'] === '',
        );
        if (!condition) {
        } else {
          const response = await agent.workflowStatus.sendAPITemp(
            statusUpdate.id,
            statusUpdate.itemId,
            statusUpdate.SubTkStatus,
          );
          if (
            statusNumber === 1 &&
            response?.data?.elementName === 'Image Restoration' &&
            statusPayload.currentSubtask === 'Restoration'
          ) {
            const updatedElementData = [...this.subtaskCompoent.elements];
            const imageRestorationIndex = updatedElementData.findIndex(
              (element) => element.elementName === 'Image Restoration',
            );
            if (imageRestorationIndex !== -1) {
              updatedElementData[imageRestorationIndex].elementValue = response
                ?.data?.elementValue
                ? response.data?.elementValue
                : `DynamicTable|${JSON.stringify([response.data[0]])}`;
            }
          }
        }
      } else {
        const response = await agent.workflowStatus.sendAPITemp(
          statusUpdate.id,
          statusUpdate.itemId,
          statusUpdate.SubTkStatus,
        );
        if (
          statusNumber === 1 &&
          response?.data?.elementName === 'Image Restoration' &&
          statusPayload.currentSubtask === 'Restoration'
        ) {
          const updatedElementData = [...this.subtaskCompoent.elements];
          const imageRestorationIndex = updatedElementData.findIndex(
            (element) => element.elementName === 'Image Restoration',
          );
          if (imageRestorationIndex !== -1) {
            updatedElementData[imageRestorationIndex].elementValue = response
              ?.data?.elementValue
              ? response.data?.elementValue
              : `DynamicTable|${JSON.stringify([response.data[0]])}`;
          }
        }
      }

      sendRespectiveEmail(
        'edited',
        title,
        'Edited WorkFlow in Asset',
        '',
        '',
        '',
        `Dear ${store.userStore?.user?.displayName},<br/>\u00A0 This notification is to inform you that you have resolved "${statusPayload.currentSubtask}" to "${store.userStore.user?.displayName}" for ${title}. <br/> <br/> Regards, <br/> info@honeycombmanager.com`,
        true,
      );
      if (statusNumber === 2 || statusNumber === 5) {
        store.dashboardStore.setTagPageNumFunc(1);
      }
      runInAction(async () => {
        toast.success('Status Update Successfully...');
        toast.info('Email Send Successfully.');
        toast.info('History Updated Sucessfully.');
        await this.resetButtons();
        await this.handleTableRecall(statusNumber, historyPayload);
      });
    } catch (error) {
      console.log(error);
    }
  };

  handleTableRecall = async (statusNumber: number, historyPayload: any) => {
    try {
      let params = {
        taskName: historyPayload.taskName || 'Cutlist Restoration',
        subtaskName: historyPayload.subTaskName || 'Restoration',
        filmTitle: this.dropdownDetails.selectedTitle,
        reelName: this.dropdownDetails.selectedReel,
        empId: store.userStore.user?.roleName !== 'Admin' &&
        !store.commonStore.filterModeOne.includes('GA01')
          ? store?.userStore?.user?.displayName 
          : this.dropdownDetails.selectedEmpId,
        empName: this.dropdownDetails.selectedEmpName
      }
      if (statusNumber === 2  || statusNumber === 5) {
        params = await this.handleTaskAndSubtaskSelection(
          historyPayload,
          params,
        );
      }
      await this.handleTableDetails(
        store?.dashboardStore?.dashboard?.setTagTablePageNumber || 0,
        params,
      );
      await (this.loader.buttonLoader = false);
    } catch (error) {
      console.log(error);
    }
  };

  handleTaskAndSubtaskSelection = async (historyPayload: any, params: any) => {
    // Retrieve task list dynamically
    const taskList = await this.handleTemplateL2(this.templateId);
  
    // Map over task roles and dynamically build the task list
    const newCurrTask = (
      roleBasedCardHiddenForTask(store.userStore.user?.roleName || '') || []
    ).map((task: string) => {
      const found = taskList.find((item: taskTypes) => item.task === task);
      return found
        ? { task: found.task, count: found.count }
        : { task, count: 0 };
    });
  
    // Dynamically filter tasks with count > 0
    const selectedTask = newCurrTask?.filter((s: taskTypes) => s.count !== 0);

    // Update task details
    this.taskDetails = newCurrTask;
  
    // Determine filtered task dynamically
    const currentTaskCountZero = newCurrTask.find((e) => e.task === historyPayload.taskName)?.count === 0
    const filteredTask =
          currentTaskCountZero
        ? selectedTask?.[0]?.task
        : historyPayload.taskName || selectedTask?.[0]?.task;
    // Retrieve subtask list based on filtered task
    const subtaskList = await this.handleTemplateL3(
      this.templateId,
      filteredTask,
    );
    // Map over subtask roles and dynamically build the subtask list
    const newCurrsubtask = (
      roleBasedCardHiddenForsubtask(filteredTask) || []
    ).map((subtask: string) => {
      const found = subtaskList.find(
        (item: subtaskTypes) => item?.subtask === subtask || '',
      );
      return found
        ? { subtask: found.subtask, count: found.count }
        : { subtask, count: 0 };
    });

    if(currentTaskCountZero){
      this.resetDropdown();
       const currentSubtask = newCurrsubtask.find(e => e.count !== 0)?.subtask
       this.selectedItems = { 
         ...this.selectedItems,
         task: filteredTask,
         subtask : currentSubtask
        };
        params = {
          taskName: filteredTask || 'Cutlist Restoration',
          subtaskName: currentSubtask || 'Restoration',
          filmTitle:'',
          reelName:'',
          empName:'',
          empId: store.userStore.user?.roleName !== 'Admin' &&
          !store.commonStore.filterModeOne.includes('GA01')
            ? store?.userStore?.user?.displayName 
            : '',
         }
       this.SubtaskDetails = newCurrsubtask;
    }

    const isSubtaskZero = this.SubtaskDetails.find(e => e.subtask === this.selectedItems.subtask)?.count === 0;
    if (this.titileInformation.count === 1 && isSubtaskZero) {
      // Filter and select subtasks with count > 0
      const selectedSubTask = newCurrsubtask?.filter(
        (s: subtaskTypes) => s.count !== 0,
      );
  
      // Update subtask details
      this.SubtaskDetails = newCurrsubtask;
  
      // Update selected subtask
      this.selectedItems = {
        ...this.selectedItems,
        subtask: selectedSubTask?.[0]?.subtask,
      };
       this.resetDropdown();
      // Update params dynamically
      params = {
        ...params,
        taskName: filteredTask || taskList?.[0]?.task || 'Default Task',
        subtaskName: selectedSubTask?.[0]?.subtask || subtaskList?.[0]?.subtask || 'Default Subtask',
        flmTitle: '',
        reelName: '',
        empId: store.userStore.user?.roleName !== 'Admin' &&
        !store.commonStore.filterModeOne.includes('GA01')
          ? store?.userStore?.user?.displayName 
          : '',
        empName: ''
      }
    }
  
    return params;
  };

  updateInitialComponents = (element: any, taskDetails: any) => {
    this.subtaskCompoent.elements = element;
    this.subtaskCompoent.elementCopy = element;
    this.subtaskCompoent.isModel = true;
    this.titileInformation.activeInformation = taskDetails;
  };

  handlOnSubmit = () => {
    const approveOrReject =
      this.subtaskCompoent.elements.filter(
        (e) => e.elementName === 'QC Approved / Reject',
      )?.[0]?.elementValue || '';
    // eslint-disable-next-line
    this.subtaskCompoent.elements.map((e) => {
      // eslint-disable-next-line
      if (
        e.readOnly === true ||
        (e.elementName === 'QC Reject Reason' && approveOrReject === 'Approved')
      )
        // eslint-disable-next-line
        return;
      // eslint-disable-next-line
      if (e.isMandatory && e.elementValue === '') {
        const localErrMsg = {
          ...this.errorMessage,
          [e.elementId]: 'This is a mandatory field',
        };
        // eslint-disable-next-line
        this.isMandatory = true;
        this.errorMessage = localErrMsg;
        this.onSubmitChecker = true;
      } else if (e.elementType === 'DynamicTable') {
        let parsedValues: any;
        try {
          const jsonPart = e.elementValue.split('|')[1];
          parsedValues = JSON.parse(jsonPart);
        } catch (error) {
          console.error('Error parsing elementValue:', error);
          // eslint-disable-next-line
          return;
        }
        e.options.forEach(({ isSelected, optionName }) => {
          if (!isSelected) return;
          const correspondingValue = parsedValues[0]?.[optionName];
          if (
            correspondingValue === '' ||
            correspondingValue === undefined ||
            correspondingValue === null ||
            (Array.isArray(correspondingValue) &&
              correspondingValue.length === 0)
          ) {
            const localErrMsg = {
              ...this.errorMessage,
              [e.elementId]: 'This is a mandatory field',
            };
            this.isMandatory = true;
            this.errorMessage = localErrMsg;
            this.onSubmitChecker = true;
          }
        });
      }
    });
  };
  titleFilter = async () => {
    try {
      const response = await NFAI_Restoration_SmartflowServices.smartTrackerTitleFilter();
      runInAction(()=>{
      this.dropdownDetails.titleList = response.data;
      })
    } catch (error) {
      console.log(error);
    }
  };
  reelFilter = async (titleName:string) => {
    try {
      const response = await NFAI_Restoration_SmartflowServices.smartTrackerReelFilter(titleName);
      runInAction(()=>{
           const sortData = response.data
          .sort((a: any, b: any) => Number(a.text) - Number(b.text))
          .map((e: any, index: number) => ({ ...e, key: index }));
        this.dropdownDetails.reelList = sortData;
      })
    } catch (error) {
      console.log(error);
    }
  };
  employeeIdFilter = async () => {
    try {
      const empIdResponse = await NFAI_Restoration_SmartflowServices.smartTrackerEmployeeIdFilter();
      runInAction(()=>{
        this.dropdownDetails.empIdList = empIdResponse.data;
      })
    } catch (error) {
      console.log(error);
    }
    
  };
  employeeNameFilter = async () => {
    try {
      const empNameResponse = await NFAI_Restoration_SmartflowServices.smartTrackerEmployeeNameFilter();
      runInAction(()=>{
        this.dropdownDetails.empNameList = empNameResponse.data
      })
    } catch (error) {
      console.log(error);
    }
  };
  updateFilterData = (Name: string, value: string) => {
    try {
      if(Name === 'title') this.dropdownDetails.selectedTitle = value
      else if(Name === 'reel')     this.dropdownDetails.selectedReel = value
      else if(Name === 'empId')    this.dropdownDetails.selectedEmpId = value
      else if(Name === 'empName')  this.dropdownDetails.selectedEmpName = value
      else console.log('updateFilterData Failed',name);
      runInAction(async ()=>{
        const params = {
          taskName: this.selectedItems.task || 'Cutlist Restoration',
          subtaskName: this.selectedItems.subtask || 'Restoration',
          filmTitle: this.dropdownDetails.selectedTitle,
          reelName: this.dropdownDetails.selectedReel,
          empId: store.userStore.user?.roleName !== 'Admin' &&
          !store.commonStore.filterModeOne.includes('GA01')
            ? store?.userStore?.user?.displayName 
            : this.dropdownDetails.selectedEmpId,
          empName: this.dropdownDetails.selectedEmpName
        }
        //eslint-disable-next-line
        store. dashboardStore.setTagPageNumFunc(1);
        await this.handleTableDetails(1,params,);
      })
    } catch (error) {
      console.log(error);
    }
  }

 cutlistStatusreport = async (titleCode: any) => {
    try {
      this.ReportsLoader = true;
      const response = await agent.NFAIReport.nfaiCutlsitStatusReport(titleCode)
      runInAction(() => {
        this.cutlistStatusReportData = response.data;
        this.ReportsLoader = false;
      });
    } catch {
      toast.error('Something went wrong. Please try again !');
      this.ReportsLoader = false;
    }
  };

  updateCutlistUserAllocation = async (params:reAllocationTypes) => {
  try {
    const payload = {
          taskName: this.selectedItems.task || 'Cutlist Restoration',
          subtaskName: this.selectedItems.subtask || 'Restoration',
          filmTitle: this.dropdownDetails.selectedTitle,
          reelName: this.dropdownDetails.selectedReel,
          empId: store.userStore.user?.roleName !== 'Admin' &&
          !store.commonStore.filterModeOne.includes('GA01')
            ? store?.userStore?.user?.displayName 
            : this.dropdownDetails.selectedEmpId,
          empName: this.dropdownDetails.selectedEmpName
        }
    await agent.NFAIReport.updateCutlistUserReallocation(params);
    await this.handleTableDetails(
        store?.dashboardStore?.dashboard?.setTagTablePageNumber || 0,
        payload,
      );
    toast.success("User reallocated successfully.");
  } catch (error) {
    console.error("Error reallocating user:", error);
    toast.error("Failed to reallocate user.");
  }
};

  getCutlistCompleteList = async (params:cutlistCompleteTypes) => {
    try {
     this.cutlistCompleteLoader.tableLoader = true;

      const { data } = await agent.NFAIReport.CutlistCompleteList(params);

      runInAction(()=> { 
        this.cutlistCompleteList = data;
        this.cutlistCompleteLoader.tableLoader = false;
      });

    } catch (error) {
      this.cutlistCompleteLoader.tableLoader = false;
      console.log(error);
    }
  } 

  getFilmTitle =async () => {
    try {
       this.cutlistCompleteLoader.filmTitleLoader = true;

       const { data } = await agent.NFAIReport.CutlistCompleteFilmTitle();

      runInAction(()=> {
        this.cutlistCompleteFilmTitleList = data.map((x: any) => ({
          key: x.id,
          text: x.title,
          value: x.title
        }));

        this.cutlistCompleteLoader.filmTitleLoader = false;
      })
    } catch (error) {
      this.cutlistCompleteLoader.filmTitleLoader = false;
      console.log(error);
    }
  }
  getReel =async (title:string) => {
      try {
        this.cutlistCompleteLoader.filmTitleLoader = true;

        const { data } = await agent.NFAIReport.CutlistcompleteReelFilter(title);

        runInAction(()=> {
          this.cutlistCompleteReelList = data;
          this.cutlistCompleteLoader.filmTitleLoader = false;
        })
      } catch (error) {
        this.cutlistCompleteLoader.filmTitleLoader = false;
        console.log(error);
      }
    }
}

